import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getInHouseAprs, updateInHouseAprs } from "../api";
import { useNotification } from "../../../contexts/NotificationContext";

export const useGetInHouseAprs = () => {
    const { data, isLoading, isError, error, isSuccess } = useQuery({
        queryKey: ['in-house-aprs'],
        queryFn: () => getInHouseAprs(),
    });

    return { data, isLoading, isSuccess, isError, error };
};

export const useUpdateInHouseAprs = () => {
    const queryClient = useQueryClient();
    const { showNotification } = useNotification();

    const mutation = useMutation({
        mutationFn: (data) => updateInHouseAprs(data),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ["in-house-aprs"] });
            showNotification('success', 'APR settings updated successfully!');
        },
        onError: (error) => {
            console.error("Error updating APR settings:", error);
            let errorMessage = 'Error updating APR settings. Please try again.';
            if (error?.response?.data?.error?.message) {
                errorMessage = error.response.data.error.message;
            } else if (error?.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error?.message) {
                errorMessage = error.message;
            }
            showNotification('danger', errorMessage);
        },
    });

    return mutation;
};
